import { CommonModule } from "@angular/common";
import { Component, EventEmitter, inject, Input, Output } from "@angular/core";

import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";

import {
  HiRecordsService,
  HistoryApiService,
  PilotDataApiService,
  PlanApiService,
  SettingsApiService,
} from "@shared/services";
import { SaveIconComponent } from "@home/components/save-icon/save-icon.component";

@Component({
  selector: "app-save-all",
  standalone: true,
  imports: [DialogModule, CommonModule, DividerModule, SaveIconComponent],
  templateUrl: "./save-all.component.html",
  styleUrl: "./save-all.component.scss",
})
export class SaveAllComponent {
  hiRecordService = inject(HiRecordsService);
  planApiService = inject(PlanApiService);
  historyApiService = inject(HistoryApiService);
  pilotDataApiService = inject(PilotDataApiService);
  settingsApiService = inject(SettingsApiService);

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  hi1Record$ = this.hiRecordService.getHiRecord("current", true);
  hi2Record$ = this.hiRecordService.getHiRecord("next", true);
  activePlan$ = this.planApiService.getPlan(true, 0);
  standbyPlan$ = this.planApiService.getPlan(true, 1);
  history$ = this.historyApiService.getHistory(true);
  pilotData$ = this.pilotDataApiService.getPilotData(true);
  settings$ = this.settingsApiService.getSettings();

  closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  isSaved(response: any): boolean {
    if (response.response) {
      return true;
    }
    return false;
  }

  hasError(response: any): boolean {
    if (response.hasError) {
      return true;
    }
    return false;
  }
}
